export const CONFIG_TYPES = {
  INTEGER: 'INTEGER',
  LIST: 'LIST',
  BOOLEAN: 'BOOLEAN'
}

export const FEATURE_CONFIG_NAMESPACES = ['CHANNELS', 'FILE_VAULT', 'SHERLOCK']
